import React from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Box } from '@mui/system';
import sideNavData from '../../../assets/sidenavData.json';

export const SideMenuLinks = () => {
  return (
    <Box
      sx={{
        mt: '15px',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        justifyContent: 'start',
        flexDirection: 'column',
        // px: 1,
        '& .MuiButton-root': {
          width: '100%',
          height: '80px',
          //my: '12px',

          // boxShadow: 'none',
          backgroundColor: 'secondary.main',
          //borderRadius: 1.5,
          // borderTopLeftRadius: 50,
          // borderBottomLeftRadius: 50,
          //pr: '5px',
        },
        '& h6': {
          width: 'inherit',
          fontWeight: 500,
          fontSize: '0.80rem',
        },
        '& a': { textDecoration: 'none' },
        '& .MuiTypography-root': { color: 'white' },
      }}
    >
      {sideNavData.map(x => {
        const isTigbauanLink = x.link.includes('https://www.tigbauan.gov.ph/');
        return (
          <Button
            href={x.link}
            target={isTigbauanLink ? '_self' : '_blank'}
            rel="noopener noreferrer"
            sx={{ p: '0px', m: 0, my: 1.5 }}
            variant="contained"
            key={x.title + x.link}
            // className="box"
          >
            <Grid container>
              <Grid item xs sx={{ textAlign: 'center', alignSelf: 'center' }}>
                <Typography variant="h6">{x.title}</Typography>
              </Grid>
            </Grid>
          </Button>
        );
      })}
    </Box>
  );
};
